import { config } from 'affiny-core/env';
import Cookies, { CookieSetOptions } from 'universal-cookie';

export const NO_ENC_COOKIE_ERROR = 'NO AUTH COOKIE';

const cookies = new Cookies();

export const getCookie = (key: string) => {
  return cookies.get(key);
};

export const cleanCookie = (key: string, options: CookieSetOptions = {}) => {
  const domains = config.env.cookies?.domains ?? [];

  // we need to remove cookie even if no domain has been set
  // adding an empty string at the end makes it possible
  [...domains, ''].forEach((domain?: string) =>
    cookies.remove(key, { ...options, domain })
  );
};

export const setCookie = (
  name: string,
  value: string,
  options: CookieSetOptions = {}
) => {
  // we force the domain to be an empty string instead of undefined
  const domain = config.env.cookies?.defaultDomain ?? '';

  cookies.set(name, value, {
    ...options,
    domain,
  });
};
